export type TextVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'h7'
  | 'h8'
  | 'subtitle1'
  | 'subtitle2'
  | 'subtitle3'
  | 'subtitle4'
  | 'subtitle5'
  | 'subtitle6'
  | 'subtitle7'
  | 'subtitle8'
  | 'subtitle9'
  | 'subtitle10'
  | 'subtitle11'
  | 'subtitle12'
  | 'subtitle13'
  | 'subtitle14'
  | 'subtitle15'
  | 'body1'
  | 'body2'
  | 'body3'
  | 'body4'
  | 'bebas1'
  | 'bebas2'
  | 'bebas3'
  | 'bebas4'
  | 'bebas5'
  | 'bebas6'
  | 'button'

export const textTagMap: Record<string, string> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  h7: 'p',
  h8: 'p',
  subtitle1: 'p',
  subtitle2: 'p',
  subtitle3: 'p',
  subtitle4: 'p',
  subtitle5: 'p',
  subtitle6: 'p',
  subtitle7: 'p',
  subtitle8: 'p',
  subtitle9: 'p',
  subtitle10: 'p',
  subtitle11: 'p',
  subtitle12: 'p',
  subtitle13: 'p',
  subtitle14: 'p',
  subtitle15: 'p',
  body1: 'p',
  body2: 'p',
  body3: 'p',
  body4: 'p',
  bebas1: 'p',
  bebas2: 'p',
  bebas3: 'p',
  bebas4: 'p',
  bebas5: 'p',
  bebas6: 'p',
  button: 'span'
}

export type TextTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label'
